import { party } from 'party-js';
import { useEffect, useRef } from 'react';
import Link from 'next/link';
import Button from './Button';
import KittyImageLayers from './KittyImageLayers';
import Modal from './Modal';
import ModalContent from './ModalContent';

const TraitShuffleSuccessModal = ({ open, onClose, kittyMetadata, kittyName }) => {
  const confettiRef = useRef(null);

  useEffect(() => {
    if (open && confettiRef.current) {
      const timer = setTimeout(() => {
        party.confetti(confettiRef.current, {
          count: party.variation.range(40, 100),
          spread: party.variation.range(50, 100),
        });
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [open]);

  const handleContinue = () => {
    onClose();
    location.reload();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalContent
        heading='🎉 Trait Shuffle Complete!'
        description={`${kittyName} has been successfully shuffled with new traits!`}
        className='text-center'
      >
        <div className='flex justify-center mb-8' ref={confettiRef}>
          <div className='w-80 h-80'>
            <KittyImageLayers metadata={kittyMetadata} className='rounded-xl shadow-2xl' />
          </div>
        </div>

        <div className='space-y-4'>
          <Button onClick={handleContinue} className='w-full'>
            Continue
          </Button>

          <div className='text-sm text-gray-600 text-center'>
            <p>
              If your kitty has layering issues, submit it to{' '}
              <Link href='/kitty-cleanup' className='text-blue-600 hover:text-blue-800 underline'>
                Kitty Cleanup
              </Link>
            </p>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default TraitShuffleSuccessModal;
